import { render, staticRenderFns } from "./AppColors.vue?vue&type=template&id=642b3e7a"
import script from "./AppColors.vue?vue&type=script&lang=ts"
export * from "./AppColors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports